import s from './financial/state'
import * as a from './financial/actions'
import * as m from './financial/mutations'
import * as g from './financial/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
